module.exports = __webpack_public_path__ + "static/media/garderobe_active_end.1f0b50a0.jpg";